import React from 'react';

import './badge.styles.scss';

export type BadgeProps = {
    variant?: 'tangerine' | 'yellow' | 'green',
};

const Badge: React.FC<BadgeProps> = ({ variant = 'yellow', children }): JSX.Element => (
    <span className={`c-badge c-badge--${variant} overline`}>
        {children}
    </span>
);

export default Badge;
